import { useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import SecSeperator from './ui/SecSeperator';

import { ICombineReducerType } from '../redux/reducers';
import { COUNTRY_TOP_LEVEL_DOMAIN, IMAGE_URL } from '../constants';
import { contentAccordToCurrentLang } from '../utils/Helper/jsHelpers';
import { addImageFallback } from '../utils/Helper/ImagePlaceholder';
import { getTopLevelDomain } from '../utils/translation';
import Rating from './ui/Rating';

export const getGoogleRating = (): number => {
    const topLevelDomain = getTopLevelDomain();
    switch (topLevelDomain) {
        case COUNTRY_TOP_LEVEL_DOMAIN.asterdio:
            return 4.7
        case COUNTRY_TOP_LEVEL_DOMAIN.bj:
            return 5
        case COUNTRY_TOP_LEVEL_DOMAIN.ci:
            return 4.8
        case COUNTRY_TOP_LEVEL_DOMAIN.coke:
            return 5
        case COUNTRY_TOP_LEVEL_DOMAIN.coza:
            return 4.9
        case COUNTRY_TOP_LEVEL_DOMAIN.ma:
            return 4.8
        case COUNTRY_TOP_LEVEL_DOMAIN.rw:
            return 4.7
        case COUNTRY_TOP_LEVEL_DOMAIN.sn:
            return 5
        case COUNTRY_TOP_LEVEL_DOMAIN.tg:
            return 5
        case COUNTRY_TOP_LEVEL_DOMAIN.tz:
            return 5
        case COUNTRY_TOP_LEVEL_DOMAIN.ug:
            return 5
        default:
            return 5
    }
};

export const getFacebookRating = (): number => {
    const topLevelDomain = getTopLevelDomain();
    switch (topLevelDomain) {
        case COUNTRY_TOP_LEVEL_DOMAIN.asterdio:
            return 4.7
        case COUNTRY_TOP_LEVEL_DOMAIN.bj:
            return 5
        case COUNTRY_TOP_LEVEL_DOMAIN.ci:
            return 4.8
        case COUNTRY_TOP_LEVEL_DOMAIN.coke:
            return 5
        case COUNTRY_TOP_LEVEL_DOMAIN.coza:
            return 5
        case COUNTRY_TOP_LEVEL_DOMAIN.ma:
            return 4.8
        case COUNTRY_TOP_LEVEL_DOMAIN.rw:
            return 4.7
        case COUNTRY_TOP_LEVEL_DOMAIN.sn:
            return 5
        case COUNTRY_TOP_LEVEL_DOMAIN.tg:
            return 5
        case COUNTRY_TOP_LEVEL_DOMAIN.tz:
            return 5
        case COUNTRY_TOP_LEVEL_DOMAIN.ug:
            return 5
        default:
            return 5
    }
};


const Promotions = () => {
    const { gallery } = useSelector(
        (state: ICombineReducerType) => state.customerGallery
    );
    // const { map } = useSelector(
    //     (state: ICombineReducerType) => state.contact.contact
    // );
    const { t, i18n } = useTranslation();

    return (
        <>{
            gallery && Array.isArray(gallery) && gallery.length > 0 &&
            <div className="promotions-container">
                <div className="promotions padding">
                    <div className="promotions-left">
                        <SecSeperator />
                        <h2 className="title" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                            {t('happycustomerHappyus', { ns: 'hero' })}
                        </h2>
                        <p className="subtitle" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>{t('loanHappyCusSubtitle')}</p>
                        {/*<a href={map} target="_blank" rel="noreferrer">*/}
                        {/*    <div className="promotions-left-imageContainer">*/}
                        {/*        <img src={getGoogleRatingImgSrcAndLink()?.image} alt="google-rating" loading="lazy" />*/}
                        {/*    </div>*/}
                        {/*</a>*/}
                        <div className="rating-content">
                            <Rating company={'Google'} rating={getGoogleRating()} />
                            <Rating company={'Facebook'} rating={getFacebookRating()} />
                        </div>

                    </div>
                    <div className="promotions-right">
                        <Swiper
                            modules={[Navigation]}
                            slidesPerView={1.7}
                            spaceBetween={16}
                            pagination={{
                                clickable: true
                            }}
                            breakpoints={{
                                '320': {
                                    slidesPerView: 1.5,
                                    spaceBetween: 10
                                },
                                '768': {
                                    slidesPerView: 2.3,
                                    spaceBetween: 16
                                },
                                '1024': {
                                    slidesPerView: 2.4,
                                    spaceBetween: 16
                                },
                                '1100': {
                                    slidesPerView: 2.6,
                                    spaceBetween: 16
                                },
                                '1200': {
                                    slidesPerView: 2.8,
                                    spaceBetween: 16
                                },
                                '1300': {
                                    slidesPerView: 3.1,
                                    spaceBetween: 16
                                }
                            }}
                            navigation
                            className="mySwiper"
                        >
                            {gallery.map((items, index) => {
                                let image =
                                    Array.isArray(items.images) &&
                                        items?.images?.length
                                        ? items?.images[0]
                                        : undefined;

                                return image ? (
                                    <SwiperSlide key={index}>
                                        <div className="carousel-item">
                                            <div className="carousel-image">
                                                <img
                                                    src={IMAGE_URL + image}
                                                    alt={items?.caption || `${items?.customerName} Review`}
                                                    onError={addImageFallback}
                                                    loading="lazy"
                                                />
                                            </div>
                                            <p className="carousel-title">
                                                {
                                                    contentAccordToCurrentLang(
                                                        items
                                                    )?.caption
                                                }{' '}
                                            </p>
                                            {/*<p>*/}
                                            {/*    <b>*/}
                                            {/*        {items?.customerName},{' '}*/}
                                            {/*        {items?.customerAddress}*/}
                                            {/*    </b>*/}
                                            {/*</p>*/}
                                            <div className="user-member">
                                                <div className="pic">
                                                    <img src="/images/user-dummy-img.webp" className="img-fluid" alt="reviewer" loading='lazy' />
                                                </div>
                                                <div className="user-info">
                                                    <span className={'default-bold-font'}> {items?.customerName}</span>
                                                    <span className="span-text font-weight-400">6 days ago</span>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ) : null;
                            })}
                        </Swiper>
                    </div>
                </div>
            </div>
        }</>
    );
};

export default Promotions;
